<div class="agent-header" 
     *ngIf="agentId !== 'module' && agentId !== 'agent_hub' && currentAgentConfig"
     [ngClass]="{'sidebar-collapsed': !isSidebarOpen, 'sidebar-open': isSidebarOpen}">
    
  <!-- LEFT SECTION: Home Button Only -->
  <div class="header-left">
    <!-- Home Button - Navigate to Agent Hub -->
    <button 
      class="agent-home-btn t-right t-no-arrow"
      (click)="onNavigateToHub()"
      [attr.data-tooltip]="'BACK_TO_AGENT_HUB_TOOLTIP' | translate"
      [attr.aria-label]="'BACK_TO_AGENT_HUB_TOOLTIP' | translate"
      aria-label="Navigate to Agent Hub">
      <span class="agent-home-icon" aria-hidden="true"></span>
    </button>
  </div>

  <!-- RIGHT SECTION: New Chat Button with Dropdown (hidden when view all sources is open) -->
  <div class="header-right" *ngIf="!isSourcePanelVisible">
    <div class="new-chat-dropdown-wrapper">
      <button 
        *ngIf = "!isNewChat"
        class="new-chat-btn t-left t-no-arrow"
         [attr.data-tooltip]="'NEW_CHAT_TOOLTIP' | translate"
        [attr.aria-label]="'NEW_CHAT_TOOLTIP' | translate"
        aria-label="New chat options">
        <!-- New Window icon - triggers new chat directly -->
        <span class="new-chat-icon-area" (click)="onAgentNewChat()" (keydown)="onNewChatIconKeydown($event)">
          <span class="new-chat-icon" aria-hidden="true"></span>
        </span>

      </button>

    </div>
  </div>
</div>

<!-- Agent Info Popup (triggered from dropdown info icon) -->
<app-agent-info-popup
  [agent]="selectedAgentForInfo"
  [isVisible]="showInfoPopup"
  (closed)="onInfoPopupClosed()"
  (useAgent)="onUseAgent($event)"
  (makeDefault)="onMakeDefaultAgent($event)">
</app-agent-info-popup>
